export default () => {
  return `
        cursor: pointer;
    `
}
